import {
  Icon,
  IconName,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import * as css from './menu.module.scss';

interface MenuLinkProps {
  label: string;
  icon: IconName;
  to: string;
  description?: string;
  active?: boolean;
  isSmall?: boolean;
}

export const MenuLink = ({
  label,
  icon,
  to,
  active,
  description,
  isSmall = false,
}: MenuLinkProps): React.JSX.Element => {
  return (
    <Link
      to={to}
      className={classNames([
        active ? css.activeLink : '',
        isSmall ? css.minifiedLink : '',
        css.link,
      ])}>
      {isSmall && (
        <Tooltip content={label}>
          <Icon name={icon} />
        </Tooltip>
      )}
      {!isSmall && (
        <>
          <Icon name={icon} />
          <span>
            <Text>{label}</Text>
            {description && (
              <Text className={css.description}>{description}</Text>
            )}
          </span>
        </>
      )}
    </Link>
  );
};
